class IdcMessagePubSubService {
    runListeners() {
        return new Promise((resolve, reject) => {
            window.addEventListener('message', (windowMessage) => {
                if (this.isMessageValid(windowMessage) && this.isCorrectMessageFormat(windowMessage)) {
                    resolve(JSON.parse(windowMessage.data));
                }
                else {
                    reject();
                }
            });
        });
    }
    sendMessageToOtherFragment(data) {
        if (document.readyState === "loading") {
            window.addEventListener("DOMContentLoaded", () => this.postMessage(data));
        }
        else {
            this.postMessage(data);
        }
    }
    isCorrectMessageFormat(windowMessage) {
        // we need to check if the message is a proper JSON, otherwise we reject the promise with no error
        try {
            JSON.parse(windowMessage.data);
            return true;
        }
        catch {
            return false;
        }
    }
    postMessage(data) {
        window.postMessage(JSON.stringify(data), window.location.origin);
    }
    isMessageValid(windowMessage) {
        // check that message contains data and verify it comes from within the same MFE page
        return !!windowMessage.data && windowMessage.origin === window.location.origin;
    }
}

var IdcMfeMessageTypes;
(function (IdcMfeMessageTypes) {
    IdcMfeMessageTypes["Navigation"] = "idc-message-mfe_navigation";
    IdcMfeMessageTypes["IsAuthorized"] = "idc-message-mfe_isAuthorized";
    IdcMfeMessageTypes["UserData"] = "idc-message-mfe_userData";
    IdcMfeMessageTypes["ScreenReaderData"] = "idc-message-mfe_accessibility_screenReader";
})(IdcMfeMessageTypes || (IdcMfeMessageTypes = {}));

/*
 * Public API Surface of idc-message-pub-sub
 */

/**
 * Generated bundle index. Do not edit.
 */

export { IdcMessagePubSubService, IdcMfeMessageTypes };
//# sourceMappingURL=idc-message-idc-message-pub-sub.mjs.map
